import React from 'react'
import { IProps } from './index'
import { SecondaryNavMenuItem } from 'marketing-site/src/library/components/SecondaryNavMenuItem'
import arrowCaret from 'marketing-site/src/library/images/menu_line.svg'
import { Chevron } from '../../elements/Chevron'
import classnames from 'classnames'
import { TIMING } from '../../utils'
import { TextLink } from '../../elements/TextLink'
import { Text } from '../../elements/Text'
import { HeaderNavigationLinkBadge } from '../HeaderNavigation/headerNavigationLinkBadge'

import { SecondaryNavSection as SecondaryNavSectionDefault } from './component'
import { BrandOptions, useBrand } from '../../providers/brandProvider'

export const SecondaryNavSection = (props: IProps): React.ReactElement => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <SecondaryNavSectionDefault {...props} />
  }
  return <SecondaryNavSectionLegacy {...props} />
}

const SecondaryNavSectionLegacy: React.FC<IProps> = ({
  title,
  badge,
  url,
  menuItems,
  isOpen = false,
}) => {
  const titleClasses = classnames('title', {
    'title--active': isOpen,
  })

  const itemsClasses = classnames('items', {
    'items--active': isOpen,
  })

  const chevronClassnames = classnames('chevron', {
    'chevron--active': isOpen,
  })

  return (
    <>
      <div style={{ maxWidth: '250px' }}>
        <div style={{ display: 'flex' }}>
          <div className={titleClasses}>
            <TextLink url={url} newWindow={false}>
              <Text size="md+">{title}</Text>
            </TextLink>
          </div>
          {badge && <HeaderNavigationLinkBadge {...badge} />}
          {menuItems && menuItems.length > 0 && (
            <span className={chevronClassnames}>
              <Chevron />
            </span>
          )}
        </div>
        <div className={itemsClasses}>
          {menuItems &&
            menuItems.map((menuItem, index) => <SecondaryNavMenuItem key={index} {...menuItem} />)}
        </div>
      </div>
      <style jsx>
        {`
          .title {
            text-decoration: none;
            &--active {
              text-decoration-style: solid;
              text-decoration-line: underline;
            }
            :global(a) {
              border: none;
            }
            :global(span) {
              cursor: pointer;
            }
          }
          .items {
            padding: 0 0 0 20px;
            height: 0px;
            overflow: hidden;
            text-decoration-style: solid;
            text-decoration-line: underline;
            &--active {
              height: auto;
              transition: height ${TIMING.FAST}ms;
            }

            :global(.item-container) {
              margin-top: 16px;
            }
          }
          .chevron {
            justify-self: end;
            align-self: center;
            background-image: url(${arrowCaret});
            background-repeat: no-repeat;
            margin-left: 10px;
            display: none;
            transform: rotate(-180deg);
            &--active {
              display: block;
            }
          }
        `}
      </style>
    </>
  )
}
